import {createSlice} from '@reduxjs/toolkit'


const bidComparsionSlice = createSlice({
    name: 'bidComparsionSlice',
    initialState: {
        disqualificationReasonDialogData: null,
        comparsionChartData: {},
        selectedGridData: [],
        bidComparsionTab: '1',
        selectedLines: {},
        selectedSequenceFromWFA: null,
        bccFilterData: {}
    },
    reducers: {
        updateDisqualificationReasonDialogData: (state, action) => {
            state.disqualificationReasonDialogData = action.payload
        },
        updateComparsionChartData: (state, action) => {
            state.comparsionChartData = action.payload
        },
        updateSelectedGridData: (state, action) => {
            state.selectedGridData = action.payload
        },
        updatebidComparsionTab: (state, action) => {
            state.bidComparsionTab = action.payload
        },
        updateSelectedLines: (state, action) => {
            state.selectedLines = action.payload
        },
        updateSelectedSequence: (state, action) => {
            state.selectedSequenceFromWFA = action.payload
        },
        updateBCCFilterData: (state, action) => {
            state.bccFilterData = action.payload
        }

    },
})

export const {
    updateDisqualificationReasonDialogData,
    updateComparsionChartData,
    updateSelectedGridData,
    updatebidComparsionTab,
    updateSelectedLines,
    updateSelectedSequence,
    updateBCCFilterData
} = bidComparsionSlice.actions

export const bidComparsionSliceDataReducer = bidComparsionSlice.reducer